import { EtapaRequisicaoCabecalhoBusca } from './etapa-requisicao-cabecalho-busca.model';
import { EtapaRequisicaoParametroBusca } from './etapa-requisicao-parametro-busca.model';
export class EtapaRequisicaoBusca {
  id?: number;
  metodo?: string;
  url?: string;
  corpo?: string;
  contentType?: string;
  cabecalhos?: EtapaRequisicaoCabecalhoBusca[] = [];
  parametros?: EtapaRequisicaoParametroBusca[] = [];
  tipoRetorno?: string;
  variaveisEnvio?: number[] = [];
}
